import { format } from "date-fns";
import { convertDateToLocalDate } from "../../../utils/date";
import Image from "next/image";
import { WineTopProps } from "../../../utils/wineRanking";
import { useAuth } from "../../../context/authContext";
import WinesTopContent from "./WinesTopContent";
import WinesTopSkeleton from "./WinesTopSkeleton";
import WinesTopContentLock from "./WinesTopContentLock";

const WinesTopPage = ({
  title,
  description,
  author,
  issueDate,
  imageUrl,
  subscribersOnly,
  wines,
}: WineTopProps) => {
  const {
    state: { loading },
  } = useAuth();

  return (
    <div>
      <article>
        {imageUrl && (
          <div className="relative xs:h-auto md:h-72 lg:h-80 aspect-[16/9] mb-4 xs:w-full sm:w-full md:w-full lg:w-3/4 mx-auto">
            <Image
              src={imageUrl}
              alt={`Cover image for ${title}`}
              priority
              className="mb-4 object-contain"
              fill
            />
          </div>
        )}

        <h1 className="text-center text-3xl font-bold mb-0">
          {title}
        </h1>

        <h2 className="mb-10 text-gray-500 text-center">
          By {author} |{" "}
          {format(convertDateToLocalDate(issueDate), "MMMM d, yyyy")}
        </h2>

        {subscribersOnly && loading ? (
          <WinesTopSkeleton />
        ) : subscribersOnly ? (
          <WinesTopContentLock description={description} wines={wines} />
        ) : (
          <WinesTopContent description={description} wines={wines} />
        )}
      </article>
    </div>
  );
};

export default WinesTopPage;
